import { Microfrontend } from '@cian/mf-react';
import * as React from 'react';
import { useSelector } from 'react-redux';

import * as styles from './DesktopFiltersMicrofrontend.css';
import { useFiltersUpdatedEvent } from './hooks/useFiltersUpdatedEvent';
import { useSaveSearchButtonEvent } from './hooks/useSaveSearchButtonEvent';
import { serializePuids } from './utils/serializePuids';
import { getDateRangeValue } from '../../../../packages/JsonQuery';
import { DESKTOP_FILTERS_MANIFEST_INFO_SETTING_KEY } from '../../constants/microfrontends';
import { selectJsonQuery } from '../../selectors/filters';
import { selectPuids } from '../../selectors/listingOffers';
import { selectIsUserAgent } from '../../selectors/user/user';
import { IManifestInfo } from '../../types/manifestInfo';
import { useApplicationContext } from '../ApplicationContext';

type MicrofrontendProps = React.ComponentProps<typeof Microfrontend>;
type JsonObject = NonNullable<MicrofrontendProps['parameters']>;

export const DesktopFiltersMicrofrontend: React.FC = () => {
  const {
    config,
    microfrontendsAPI,
    microfrontendsRegistry,
    custom: { source },
  } = useApplicationContext();
  const manifestInfo = config.get<IManifestInfo | null>(DESKTOP_FILTERS_MANIFEST_INFO_SETTING_KEY);

  useFiltersUpdatedEvent();
  useSaveSearchButtonEvent();

  const isUserAgent = useSelector(selectIsUserAgent);
  const adfoxPuids = useSelector(selectPuids);
  const jsonQuery = useSelector(selectJsonQuery);
  const hasNoDates = !getDateRangeValue('dates')(jsonQuery);

  const parameters = React.useMemo(
    () => ({
      adfoxPuids: serializePuids(adfoxPuids),
      professionalSearchAvailable: isUserAgent,
      jsonQuery: jsonQuery as unknown as JsonObject,
    }),
    [adfoxPuids, isUserAgent, jsonQuery],
  );

  React.useEffect(() => {
    if (
      source === 'search_string' &&
      hasNoDates &&
      microfrontendsRegistry.microfrontend('desktop-filters-micro-frontend') &&
      microfrontendsAPI
    ) {
      microfrontendsAPI.desktopFilters.openDatesPopup();
    }
  }, [hasNoDates, microfrontendsAPI, microfrontendsRegistry, source]);

  if (!manifestInfo) {
    return null;
  }

  return (
    <div className={styles['root']} data-testid="desktop-filters-microfrontend">
      <Microfrontend {...manifestInfo} parameters={parameters} />
    </div>
  );
};
